// components
import maModal from '@/components/modal'
import maInput from '@/components/input/modules/text'
import maButton from '@/components/button-blue'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
  name: 'calculateSurfaceModal',

  props: {
    pieceId: {
      defult: null,
      type: Number | null
    },
    modalIsOpen: {
      default: false,
      type: Boolean
    }
  },
  data: function() {
    return {
      inputWidthSurfaceValue: 0,
      inputLengthSurfaceValue: 0
    }
  },
  validations: {
    inputWidthSurfaceValue: {
      required,
      minValue: minValue(1)
    },
    inputLengthSurfaceValue: {
      required,
      minValue: minValue(1)
    }
  },
  components: {
    maModal,
    maInput,
    maButton
  },
  computed: {
    formHasErrors() {
      return this.$v.$anyError
    },
    mainBtnIsDisabled() {
      return this.formHasErrors || (this.inputWidthSurfaceValue === 0 || this.inputLengthSurfaceValue === 0)
    }
  },
  methods: {
    handleModal(modalIsOpen) {
      if (!modalIsOpen) {
        this.resetForms()
        this.$emit('closeSurfaceModal')
      }
      this.$refs.calculateSurfaceModal.showModal = modalIsOpen
    },

    hideModal() {
      this.$refs.calculateSurfaceModal.showModal = false
    },

    resetForms() {
      this.$v.$reset()
      this.inputWidthSurfaceValue = 0
      this.inputLengthSurfaceValue = 0
    },

    handleCalculateSurface() {
      this.$emit('calculateSurface', {
        length: this.inputLengthSurfaceValue,
        width: this.inputWidthSurfaceValue
      })
    }
  },

  watch: {
    modalIsOpen() { this.handleModal(this.modalIsOpen) }
  }
}
